<template>
    <div class="float-left mr-2">
        <span class="text-primary">
            <i
                class="fa fa-download fa-lg icon-button"
                title="Download"
                @click.stop="download()"
            ></i>
        </span>
    </div>
</template>

<script>
import ProcessosJudiciaisServicos from './ProcessosJudiciaisServicos'

export default {
    props: {
        processo: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        download() {
            this.$store.dispatch('addRequest')
            ProcessosJudiciaisServicos.download(this.processo).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.processo.documento)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
